export default "__VITE_ASSET__CLLDsBZg__"